
(function() {
  var result = { translations: { "tr": { "i18n": { "duration": { "seconds": "{{ seconds }} sn.", "minutes": "{{ minutes }} dk.", "hours": "{{ hours }} sa.", "hoursAndMinutes": "{{ hours }} sa. {{ minutes }} dk.", "days": "{{ days }} g\xFCn", "shortForm": { "seconds": "{{ seconds }}sn.", "minutes": "{{ minutes }}dk.", "hours": "{{ hours }}sa.", "days": "{{ days }}g\xFCn", "hoursAndMinutes": "{{ hours }}sa. {{ minutes }}dk." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}. \xC7 {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, dahili {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "tr": "static-7.818"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.818",
    "ar-eg": "static-7.818",
    "bg": "static-7.818",
    "bn": "static-7.818",
    "ca-es": "static-7.818",
    "cs": "static-7.818",
    "da": "static-7.818",
    "de": "static-7.818",
    "el": "static-7.818",
    "en-gb": "static-7.818",
    "en": "static-7.818",
    "es-mx": "static-7.818",
    "es": "static-7.818",
    "fi": "static-7.818",
    "fr-ca": "static-7.818",
    "fr": "static-7.818",
    "he-il": "static-7.818",
    "hr": "static-7.818",
    "hu": "static-7.818",
    "id": "static-7.818",
    "it": "static-7.818",
    "ja": "static-7.818",
    "ko": "static-7.818",
    "lt": "static-7.818",
    "ms": "static-7.818",
    "nl": "static-7.818",
    "no": "static-7.818",
    "pl": "static-7.818",
    "pt-br": "static-7.818",
    "pt-pt": "static-7.818",
    "ro": "static-7.818",
    "ru": "static-7.818",
    "sk": "static-7.818",
    "sl": "static-7.818",
    "sv": "static-7.818",
    "th": "static-7.818",
    "tl": "static-7.818",
    "tr": "static-7.818",
    "uk": "static-7.818",
    "vi": "static-7.818",
    "x-pseudo": "static-7.818",
    "zh-cn": "static-7.818",
    "zh-hk": "static-7.818",
    "zh-tw": "static-7.818"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:tr', {version: 'static-7.818'}); }
})();


